// import Vue from 'vue'
// import App from './App.vue'

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import application from '@/application';
import lawConfig from '@/lawConfig';
import router from './router';
import store from './store/bend';
import '@baidu/iconfont/font.css';
import iView from '@baidu/du-iview';
import './assets/css/style.styl';
import '@baidu/du-iview/dist/styles/iview.css';
import wywLog from './utils/ubcLog';
import {initUbcLog} from './utils/law/log';
import $http from './utils/ajax';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Directives from '@/directives';
import 'intersection-observer/intersection-observer';
import Weirwood from './weirwood/weirwood.config';
import {DatePicker} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

// 添加weirwood性能监控
Vue.use(Weirwood, process.env.NODE_ENV === 'production');
// Vue.use(Weirwood, true);

// 加在自定义指令
Vue.use(Directives);

Vue.use(iView);
Vue.use(VueQuillEditor);

// 按需引入element-ui组件
Vue.component(DatePicker.name, DatePicker);

/* eslint-disable no-new */
(async () => {
    // 律临：初始化打点实例
    Vue.prototype.$log = initUbcLog();
    Vue.prototype.$wywLog = wywLog;

    const app = await application.register(lawConfig);
    const appStore = store.init(app.store);
    // 路由list
    const appRouter = router.init(appStore);
    app.router = appRouter;

    let bpUserInfo = '/bp/api/user/info';
    const dataInfo = await Promise.all(
        [$http.get(bpUserInfo)]
    );
    // 已登录
    if (dataInfo && dataInfo[0]?.code !== '10010') {
        let userInfoNew = dataInfo[0]?.data || {};
        userInfoNew && appStore.commit('lawStore/setUserInfoNew', userInfoNew);
        await appStore.dispatch('lawStore/getVipInfo');
        let vipInfo = appStore?.state?.lawStore?.vipInfo || {};
        appStore.dispatch('Menu/updateMenu', {userInfo: userInfoNew, vipInfo});
        appStore.dispatch('Menu/init', app);
        Vue.prototype.bend = app;
        // 代理商角色-查询成员列表
        if (userInfoNew && +userInfoNew.user_role === 1) {
            appStore.dispatch('lawStore/getAgentMemberData');
        }
        try {
            await appStore.dispatch('lawStore/getVipInfo');
        }
        catch (err) {}
    }
    Vue.prototype.lastLoginTime = +(new Date());
    // 存储每个页面的打开时间
    let pageStartTimeObj = {};
    // 页面曝光打点
    appRouter.afterEach((to, from) => {
        const toPageName = to.name || 'law';
        const fromPageName = from.name || 'law';
        pageStartTimeObj[toPageName] = Date.now();
        let lengthOfStay = Date.now() - pageStartTimeObj[fromPageName];
        const fr = to.query.from || to.query.fr || '';
        const {vipStatusName} = appStore.state && appStore.state.lawStore && appStore.state.lawStore.vipInfo || {};
        const {uk} = appStore.state && appStore.state.lawStore && appStore.state.lawStore.userInfoNew || {};
        wywLog.addKey({
            fr,
            page: toPageName,
            vipStatusName,
            uk
        });
        // 最初进入时设置一个贯穿始终的originFr作为原始来源，之后不再覆盖
        if (wywLog.logKey && wywLog.logKey.originFr === undefined) {
            wywLog.addKey({
                originFr: fr
            });
        }
        wywLog.send({
            serverId: 16814,
            action: 'show',
            area: 'pv'
        });
        // 页面停留时长打点
        wywLog.send({
            serverId: 16853,
            action: 'duration',
            area: 'duration',
            dur: lengthOfStay || '',
            page: fromPageName
        });
    });

    application.run({
        el: '#app',
        router: appRouter,
        store: appStore,
        render: h => h(App)
    });
})();

